/*!
 * utils.js - utils for javascript
 * Copyright (c) 2018, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcrypto
 */

/* eslint spaced-comment: "off" */
'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(lines);

var assert = require('bsert');
/*
 * Constants
 */


var ZERO = Buffer.alloc(1, 0x00);
var cache = [];
/*
 * Util
 */

function countBits(buf) {
  assert(Buffer.isBuffer(buf));
  var i = 0;

  for (; i < buf.length; i++) {
    if (buf[i] !== 0x00) break;
  }

  var bits = (buf.length - i) * 8;
  if (bits === 0) return 0;
  bits -= 8;
  var oct = buf[i];

  while (oct) {
    bits += 1;
    oct >>>= 1;
  }

  return bits;
}

function trimZeroes(buf) {
  if (buf == null) return ZERO;
  assert(Buffer.isBuffer(buf));
  if (buf.length === 0) return ZERO;
  if (buf[0] !== 0x00) return buf;

  for (var i = 1; i < buf.length; i++) {
    if (buf[i] !== 0x00) return buf.slice(i);
  }

  return buf.slice(-1);
}

function getZero(size) {
  assert(size >>> 0 === size);
  assert(size <= 128);

  while (cache.length < size) {
    cache.push(null);
  }

  var zero = cache[size];

  if (!zero) {
    zero = Buffer.alloc(size, 0x00);
    cache[size] = zero;
  }

  return zero;
}

function leftPad(val, size) {
  if (val == null) return getZero(size);
  assert(Buffer.isBuffer(val));
  assert(size >>> 0 === size);
  if (val.length > size) val = trimZeroes(val);
  assert(val.length <= size);
  if (val.length === size) return val;
  var buf = Buffer.allocUnsafe(size);
  var pos = size - val.length;
  buf.fill(0x00, 0, pos);
  val.copy(buf, pos);
  return buf;
}

function lines(str) {
  var i, j, ch, line, _line;

  return _regeneratorRuntime.wrap(function lines$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          assert(typeof str === 'string');
          i = 0;
          j = 0;

          if (str.length > 0) {
            if (str.charCodeAt(0) === 0xfeff) {
              i += 1;
              j += 1;
            }
          }

        case 4:
          if (!(i < str.length)) {
            _context.next = 20;
            break;
          }

          ch = str.charCodeAt(i);
          _context.t0 = ch;
          _context.next = _context.t0 === 0x0d
          /*'\r'*/
          ? 9 : _context.t0 === 0x0a
          /*'\n'*/
          ? 9 : 17;
          break;

        case 9:
          if (!(j !== i)) {
            _context.next = 14;
            break;
          }

          line = trimRight(str.substring(j, i));

          if (!(line.length > 0)) {
            _context.next = 14;
            break;
          }

          _context.next = 14;
          return line;

        case 14:
          if (ch === 0x0d && i + 1 < str.length) {
            if (str.charCodeAt(i + 1) === 0x0a) i += 1;
          }

          j = i + 1;
          return _context.abrupt("break", 17);

        case 17:
          i++;
          _context.next = 4;
          break;

        case 20:
          if (!(j !== i)) {
            _context.next = 25;
            break;
          }

          _line = trimRight(str.substring(j, i));

          if (!(_line.length > 0)) {
            _context.next = 25;
            break;
          }

          _context.next = 25;
          return _line;

        case 25:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function trimRight(str) {
  assert(typeof str === 'string');

  for (var i = str.length - 1; i >= 0; i--) {
    var ch = str.charCodeAt(i);

    switch (ch) {
      case 0x09
      /*'\t'*/
      :
      case 0x0b
      /*'\v'*/
      :
      case 0x20
      /*' '*/
      :
        continue;
    }

    return str.substring(0, i + 1);
  }

  return str;
}
/*
 * Expose
 */


exports.countBits = countBits;
exports.trimZeroes = trimZeroes;
exports.getZero = getZero;
exports.leftPad = leftPad;
exports.lines = lines;